import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchProducer(organization_id, producer_id) {
    return RequesterV1.get(
      `organization/certifications/basic_certifications_producers/manage_field_certification/${organization_id}/fetch_producer/${producer_id}`
    );
  },
  fetchCropFieldCertifications(organization_id, producer_id) {
    return RequesterV1.get(
      `organization/certifications/basic_certifications_producers/manage_field_certification/${organization_id}/fetch_crop_field_certifications/${producer_id}`
    );
  },
  fetchCropFieldCertification(
    organization_id,
    producer_id,
    crop_field_certification_id
  ) {
    return RequesterV1.get(
      `organization/certifications/basic_certifications_producers/manage_field_certification/${organization_id}/fetch_crop_field_certification/${producer_id}/${crop_field_certification_id}`
    );
  },
  fetchCertifications(organization_id, producer_id) {
    return RequesterV1.get(
      `organization/certifications/basic_certifications_producers/manage_field_certification/${organization_id}/fetch_certifications/${producer_id}`
    );
  },
  fetchCropFields(organization_id, producer_id) {
    return RequesterV1.get(
      `organization/certifications/basic_certifications_producers/manage_field_certification/${organization_id}/fetch_crop_fields/${producer_id}`
    );
  },
  create(organization_id, producer_id, crop_field_certification) {
    return RequesterV1.post(
      `organization/certifications/basic_certifications_producers/manage_field_certification/${organization_id}/create/${producer_id}`,
      { crop_field_certification: crop_field_certification }
    );
  },
  update(
    organization_id,
    producer_id,
    crop_field_certification_id,
    crop_field_certification
  ) {
    return RequesterV1.post(
      `organization/certifications/basic_certifications_producers/manage_field_certification/${organization_id}/update/${producer_id}/${crop_field_certification_id}`,
      { crop_field_certification }
    );
  },
  destroy(agro_exporter_id, organization_id, organization_certification_id) {
    return RequesterV1.get(
      `organization/certifications/basic_certifications_producers/manage_field_certification/${agro_exporter_id}/destroy/${organization_id}/${organization_certification_id}`
    );
  }
};
